import { __decorate, __metadata } from "tslib";
// NPM
import _ from "lodash";
import { clearInterval, setInterval } from "worker-timers";
import { AdjustEntryModel } from "@/store/models/clockWork/adjustEntry";
import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { toaster } from "@/utilities/toaster";
import clockPicker from "@/components/widgets/clockPicker.vue";
import simplebar from "simplebar-vue";
import { Guid } from "guid-typescript";
import BaseMixer from "@/router/views/BaseMixer";
import { setInteractionMode } from "vee-validate";
import { interpret } from "xstate/lib/interpreter";
import { checkGaps } from "@/types/gapChecker";
import clockWorkSliderMachine from "./machines/clockWorkSliderMachine";
import DeleteComponent from "../deleteComponent.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let AdjustEntrySlider = /** @class */ (() => {
    let AdjustEntrySlider = class AdjustEntrySlider extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.currentTime = new Date();
            this.totalhours = 18;
            this.startHour = 6;
            this.segments = [];
            this.hours = Array.from({ length: this.totalhours + 1 }, (_, i) => i * (100 / this.totalhours));
            this.halfHours = Array.from({ length: this.totalhours * 2 + 1 }, (_, i) => i * (100 / (this.totalhours * 2)));
            this.dragging = false;
            this.currentSegment = null;
            this.currentSide = null;
            this.selectedSegment = null;
            this.refreshClockPickerKey = false;
            this.interval = 0;
            this.hoverTime = null;
            this.hoverX = 0;
            this.hoverDisplayTime = "";
            this.splitX = 0;
            this.selectedPicker = null;
            this.segmentId = null;
            this.gapFillMsg = "Click to set this time as ";
            this.gapFillMsgDown = " to fix the gap with the entry below.";
            this.gapFillMsgUp = " to fix the gap with the entry above.";
            this.machine = clockWorkSliderMachine.withContext({
                deletedEntries: [],
                isSavedSuccessful: false,
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
            this.colors = ["#556EE6", "#34C38F", "#F1B44C", "#495057", "#008080", "#E83E8C", "#6F42C1", "#F1734F", "#576490", "#50A5F1"];
            this.parseTimeTo24Hour = (time12h) => {
                const [time, modifier] = time12h.split(" ");
                let [hours, minutes] = time.split(":").map(Number);
                if (modifier === "PM" && hours !== 12) {
                    hours += 12;
                }
                if (modifier === "AM" && hours === 12) {
                    hours = 0;
                }
                return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
            };
        }
        send(event) {
            this.machineService.send(event);
        }
        get maxPercentage() {
            return this.is12AMEnd ? 100 - this.oneMinutePercentage : 100;
        }
        get is12AMEnd() {
            return this.formatLabelTime(100) == "12:00 AM";
        }
        get fiveMinutePercentage() {
            return (5 / (this.totalhours * 60)) * 100;
        }
        get oneMinutePercentage() {
            return (1 / (this.totalhours * 60)) * 100;
        }
        get isEntriesUpdated() {
            return this.state.hasTag("savingEntries") && this.segments.some((x) => x.start !== x.initialStart || x.end !== x.initialEnd || x.isSplitted || x.isDescriptionChanged);
        }
        get currentTimeInPercentage() {
            const now = this.currentTime;
            const currentHour = now.getHours();
            const currentMinute = now.getMinutes();
            const totalMinutes = (currentHour - this.startHour) * 60 + currentMinute;
            const percentage = (totalMinutes / (this.totalhours * 60)) * 100;
            return percentage;
        }
        get reverseSegments() {
            return [...this.segments].reverse();
        }
        handlePickerToggle(picker, index) {
            if (this.selectedSegment === index) {
                if (this.selectedPicker === picker) {
                    this.selectedPicker = null;
                }
                else {
                    this.selectedPicker = picker;
                }
            }
            else {
                this.selectedSegment = index;
                this.selectedPicker = picker;
            }
        }
        updateTime() {
            this.currentTime = new Date();
        }
        entryBgColor(index) {
            if (index > 9) {
                index = index % 10;
            }
            return this.colors[index];
        }
        onDragStart(event, index, side) {
            this.dragging = true;
            this.currentSegment = index;
            this.currentSide = side;
            document.addEventListener("mousemove", this.onDragging);
            document.addEventListener("mouseup", this.onDragEnd);
            // Optional: For touch support (if needed)
            document.addEventListener("touchmove", this.onDragging);
            document.addEventListener("touchend", this.onDragEnd);
        }
        onDragging(event) {
            if (!this.dragging)
                return;
            let clientX;
            if (event instanceof TouchEvent) {
                clientX = event.touches[0].clientX;
            }
            else {
                clientX = event.clientX;
            }
            ////const container = this.$el;
            const container = this.$el.querySelector(".timeline-container");
            const rect = container.getBoundingClientRect();
            let percentage = ((clientX - rect.left) / rect.width) * 100;
            // Round to the nearest 5 minutes
            const totalMinutes = this.totalhours * 60;
            let minutes = (percentage / 100) * totalMinutes;
            const roundedMinutes = Math.round(minutes / 5) * 5;
            percentage = (roundedMinutes / totalMinutes) * 100;
            this.segments = this.segments.map((segment, i) => {
                if (i === this.currentSegment) {
                    let newStart = this.currentSide === "start" ? Math.max(percentage, this.getPreviousEndOnDragging(segment)) : segment.start;
                    let newEnd = this.currentSide === "end" ? Math.min(percentage, this.getNextStartOnDragging(segment)) : segment.end;
                    const minimumGapPercentage = (5 / totalMinutes) * 100;
                    if (this.currentSide === "start" && newStart > newEnd - minimumGapPercentage) {
                        if (segment.isRunning) {
                            newStart = newEnd - minimumGapPercentage;
                            let newStartMinutes = (newStart / 100) * totalMinutes;
                            const newStartRoundedMinutes = Math.round(newStartMinutes / 5) * 5;
                            newStart = (newStartRoundedMinutes / totalMinutes) * 100;
                        }
                        else {
                            newStart = newEnd - minimumGapPercentage;
                        }
                    }
                    if (this.currentSide === "end" && newEnd < newStart + minimumGapPercentage) {
                        newEnd = newStart + minimumGapPercentage;
                    }
                    const startValue = Math.min(newStart, newEnd);
                    const endValue = Math.max(newStart, newEnd);
                    let entryDate = new Date(segment.entryDate);
                    const datePart = entryDate.toISOString().split("T")[0];
                    const startTimeValue = this.formatLabelTime(startValue);
                    const startTime24Hour = this.parseTimeTo24Hour(startTimeValue);
                    const startTimeString = `${datePart}T${startTime24Hour}:00`;
                    const startTimeDate = new Date(startTimeString);
                    var model = new AdjustEntryModel();
                    model.id = segment.id;
                    model.isRunning = segment.isRunning;
                    model.initialStart = segment.initialStart;
                    model.initialEnd = segment.initialEnd;
                    model.start = startValue;
                    model.end = endValue;
                    model.startTime = this.formatLabelTime(startValue);
                    model.endTime = !segment.isRunning ? this.formatLabelTime(endValue) : "now";
                    model.description = segment.description;
                    model.entryDate = segment.entryDate;
                    model.entryAtWork = segment.entryAtWork;
                    model.orginalStartTime = startTimeDate;
                    model.isSplitted = segment.isSplitted;
                    model.isDescriptionChanged = segment.isDescriptionChanged;
                    model.taskId = segment.taskId;
                    model.isStopped = false;
                    return model;
                }
                return segment;
            });
            checkGaps(this.segments);
        }
        onDragEnd() {
            const refKey = this.currentSide === "start" ? `entryStartTime-${this.selectedSegment}` : `entryEndTime-${this.selectedSegment}`;
            const clockPicker = this.$refs[refKey][0];
            if (clockPicker) {
                clockPicker.apply();
            }
            this.dragging = false;
            this.currentSegment = null;
            this.currentSide = null;
            document.removeEventListener("mousemove", this.onDragging);
            document.removeEventListener("mouseup", this.onDragEnd);
            // Optional: For touch support (if needed)
            document.addEventListener("touchmove", this.onDragging);
            document.addEventListener("touchend", this.onDragEnd);
        }
        getPreviousEndOnDragging(segment) {
            var index = this.segments.indexOf(segment);
            return index > 0 ? this.segments[index - 1].end : 0;
        }
        getNextStartOnDragging(segment) {
            var index = this.segments.indexOf(segment);
            return index < this.segments.length - 1 ? this.segments[index + 1].start : this.isToday ? this.roundedCurrentTimeToFiveMinutes() : this.maxPercentage;
        }
        roundedCurrentTimeToFiveMinutes() {
            const totalMinutes = this.totalhours * 60;
            let minutes = (this.currentTimeInPercentage / 100) * totalMinutes;
            const roundedMinutes = Math.floor(minutes / 5) * 5;
            const percentage = (roundedMinutes / totalMinutes) * 100;
            return percentage;
        }
        formatHour(hour, isLower = false) {
            const amText = isLower ? "am" : "AM";
            const pmText = isLower ? "pm" : "PM";
            const period = hour >= 12 && hour < 24 ? pmText : amText;
            const formattedHour = hour > 12 ? hour - 12 : hour;
            return `${formattedHour} ${period}`;
        }
        formatLabelTime(percentage) {
            const time = (percentage / 100) * this.totalhours;
            var hours = Math.floor(time) + this.startHour;
            var minutes = Math.round((time - Math.floor(time)) * 60);
            if (minutes === 60) {
                minutes = 0;
                hours += 1;
            }
            const [hour, period] = this.formatHour(hours).split(" ");
            return `${hour}:${minutes < 10 ? "0" : ""}${minutes} ${period}`;
        }
        calculateTimeValue(timeString) {
            const [time, period] = timeString.split(" ");
            let [hours, minutes] = time.split(":").map(Number);
            if (period === "PM" && hours !== 12) {
                hours += 12;
            }
            else if (period === "AM" && hours === 12) {
                hours = 0;
            }
            //const totalHoursSinceStart = (((hours >= this.startHour ? hours : hours + 24) - this.startHour) * 60 + minutes) / 60;
            const totalHoursSinceStart = ((hours - this.startHour) * 60 + minutes) / 60;
            const percentage = (totalHoursSinceStart / this.totalhours) * 100;
            return percentage;
        }
        IsSavedSuccessFul() {
            return this.state.context.isSavedSuccessful;
        }
        async saveEntries() {
            const observers = Array.isArray(this.$refs.editEntryObserver) ? this.$refs.editEntryObserver : [this.$refs.editEntryObserver];
            const validationResults = await Promise.all(observers.map((observer) => observer.validate()));
            const allValid = validationResults.every((result) => result);
            if (allValid) {
                var entriesToUpdate = [...this.segments.filter((x) => x.start !== x.initialStart || x.end !== x.initialEnd || x.isSplitted || x.isDescriptionChanged || x.isStopped)];
                if (entriesToUpdate.length > 0) {
                    entriesToUpdate.forEach((x) => {
                        if (x.isRunning) {
                            x.endTime = "now";
                        }
                    });
                    this.send({ type: "SAVE_ENTRIES", entriesToUpdate: entriesToUpdate });
                }
            }
        }
        adjustStartTimeInSegment(time) {
            const currentSegment = this.segments[this.selectedSegment];
            const adjustedTime = this.calculateTimeValue(time);
            const previousSegment = this.selectedSegment > 0 ? this.segments[this.selectedSegment - 1] : null;
            const isTimeBeforePreviousSegmentEnd = (adjustedTime, previousSegment) => {
                return previousSegment && adjustedTime < previousSegment.end;
            };
            const adjustStartTimeToPreviousSegmentEnd = (currentSegment, previousSegment) => {
                currentSegment.start = previousSegment.end;
                currentSegment.startTime = previousSegment.endTime;
                this.refreshClockPickerKey = !this.refreshClockPickerKey;
            };
            const isTimeExceedingCurrentSegmentEnd = (adjustedTime, currentSegment) => {
                return adjustedTime > currentSegment.end - this.fiveMinutePercentage;
            };
            const adjustStartTimeToCurrentSegmentEnd = (currentSegment) => {
                currentSegment.start = currentSegment.end - this.fiveMinutePercentage;
                currentSegment.startTime = this.formatLabelTime(currentSegment.start);
                this.refreshClockPickerKey = !this.refreshClockPickerKey;
            };
            const isTimeNegative = (adjustedTime) => {
                return adjustedTime < 0;
            };
            const adjustStartTimeToZero = (currentSegment) => {
                currentSegment.start = 0;
                currentSegment.startTime = this.formatLabelTime(currentSegment.start);
                this.refreshClockPickerKey = !this.refreshClockPickerKey;
            };
            if (isTimeBeforePreviousSegmentEnd(adjustedTime, previousSegment)) {
                adjustStartTimeToPreviousSegmentEnd(currentSegment, previousSegment);
                toaster.ShowError("Start time cannot be set earlier than the previous entry's end time.");
            }
            else if (isTimeExceedingCurrentSegmentEnd(adjustedTime, currentSegment)) {
                adjustStartTimeToCurrentSegmentEnd(currentSegment);
                toaster.ShowError("Start time cannot exceed 5 minutes before end time.");
            }
            else if (isTimeNegative(adjustedTime)) {
                adjustStartTimeToZero(currentSegment);
                toaster.ShowError("You can not set the start time beyond the timeline.");
            }
            else {
                currentSegment.start = adjustedTime;
            }
            checkGaps(this.segments);
        }
        adjustEndTimeInSegment(time) {
            const currentSegment = this.segments[this.selectedSegment];
            const adjustedTime = this.calculateTimeValue(time);
            const nextSegment = this.selectedSegment < this.segments.length - 1 ? this.segments[this.selectedSegment + 1] : null;
            const isTimeAfterNextSegmentStart = (adjustedTime, nextSegment) => {
                return nextSegment && adjustedTime > nextSegment.start;
            };
            const adjustEndTimeToNextSegmentStart = (currentSegment, nextSegment) => {
                currentSegment.end = nextSegment.start;
                currentSegment.endTime = nextSegment.startTime;
                this.refreshClockPickerKey = !this.refreshClockPickerKey;
            };
            const isTimeLessThanCurrentStartPlusFiveMinutes = (adjustedTime, currentSegment) => {
                return adjustedTime < currentSegment.start + this.fiveMinutePercentage;
            };
            const adjustEndTimeToCurrentStartPlusFiveMinutes = (currentSegment) => {
                currentSegment.end = currentSegment.start + this.fiveMinutePercentage;
                currentSegment.endTime = this.formatLabelTime(currentSegment.end);
                this.refreshClockPickerKey = !this.refreshClockPickerKey;
            };
            const isTimeGreaterThanHundred = (adjustedTime) => {
                return adjustedTime > 100;
            };
            const adjustEndTimeToHundred = (currentSegment) => {
                currentSegment.end = this.maxPercentage;
                currentSegment.endTime = this.formatLabelTime(currentSegment.end);
                this.refreshClockPickerKey = !this.refreshClockPickerKey;
            };
            const isTimeGreaterThanRoundedCurrentTime = (adjustedTime) => {
                return this.isToday && adjustedTime > this.roundedCurrentTimeToFiveMinutes();
            };
            const adjustEndTimeToRoundedCurrentTime = (currentSegment) => {
                currentSegment.end = this.roundedCurrentTimeToFiveMinutes();
                currentSegment.endTime = this.formatLabelTime(currentSegment.end);
                this.refreshClockPickerKey = !this.refreshClockPickerKey;
            };
            if (isTimeAfterNextSegmentStart(adjustedTime, nextSegment)) {
                adjustEndTimeToNextSegmentStart(currentSegment, nextSegment);
                toaster.ShowError("The end time cannot be set later than the next entry's start time.");
            }
            else if (isTimeLessThanCurrentStartPlusFiveMinutes(adjustedTime, currentSegment)) {
                adjustEndTimeToCurrentStartPlusFiveMinutes(currentSegment);
                toaster.ShowError("End time cannot be set beyond 5 minutes after start time.");
            }
            else if (isTimeGreaterThanHundred(adjustedTime)) {
                adjustEndTimeToHundred(currentSegment);
                toaster.ShowError("End time cannot be after timeline end.");
            }
            else if (isTimeGreaterThanRoundedCurrentTime(adjustedTime)) {
                adjustEndTimeToRoundedCurrentTime(currentSegment);
                toaster.ShowError("End time cannot exceed the live entry's time.");
            }
            else {
                currentSegment.end = adjustedTime;
            }
            checkGaps(this.segments);
        }
        selectSegment(index) {
            if (!this.state.hasTag("splitEntry")) {
                this.selectedSegment = index;
                this.selectedPicker = null;
            }
        }
        calculateDuration(segment) {
            const totalSeconds = this.totalhours * 60 * 60;
            const startSeconds = (segment.start / 100) * totalSeconds;
            const endSeconds = (segment.end / 100) * totalSeconds;
            const durationSeconds = Math.round(endSeconds - startSeconds);
            let date = new Date(0);
            date.setSeconds(durationSeconds);
            return date.toISOString().substr(11, 5);
        }
        shouldShowSpliEntry(segment) {
            const timeDifference = this.calculateMinutesDifference(segment.start, segment.end);
            return timeDifference >= 12 && !segment.isRunning;
        }
        isSplitDisabled(segment) {
            return this.selectedSegment !== this.segments.indexOf(this.segments.find((x) => x.id === segment.id)) && this.state.hasTag("splitEntry");
        }
        calculateMinutesDifference(startPercentage, endPercentage) {
            const startTime = this.formatLabelTime(startPercentage);
            const endTime = this.formatLabelTime(endPercentage);
            const { startDate, endDate } = this.parseTimeToDate(startTime, endTime);
            const diffInMinutes = (endDate.getTime() - startDate.getTime()) / (1000 * 60);
            return diffInMinutes;
        }
        parseTimeToDate(startTime, endTime) {
            const parseTime = (timeString) => {
                const [time, period] = timeString.split(" ");
                let [hours, minutes] = time.split(":").map(Number);
                if (period === "PM" && hours !== 12) {
                    hours += 12;
                }
                else if (period === "AM" && hours === 12) {
                    hours = 0;
                }
                return new Date(`1970-01-01T${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:00Z`);
            };
            const startDate = parseTime(startTime);
            const endDate = parseTime(endTime);
            return { startDate, endDate };
        }
        handleSplitEntry(index) {
            this.send({ type: "SPLIT_ENTRY" });
            this.selectedSegment = index;
            const segment = this.segments[this.selectedSegment];
            const startMinutes = this.getSegmentTimeInMinutes(segment.startTime);
            const endMinutes = this.getSegmentTimeInMinutes(segment.endTime);
            this.hoverTime = Math.floor((startMinutes + endMinutes) / 2);
            this.hoverDisplayTime = this.formatTimeFromMinutes(this.hoverTime);
            this.hoverX = 50.0;
            this.splitX = this.hoverX;
        }
        OnSplitHandleDragging(event) {
            if (this.state.hasTag("splitEntry") && this.selectedSegment !== null) {
                const segment = this.segments[this.selectedSegment];
                const container = this.$el.querySelector(".timeline-container");
                if (!container)
                    return;
                const rect = container.getBoundingClientRect();
                const mousePosition = event.clientX - rect.left;
                const containerWidth = rect.width;
                let mousePercentage = (mousePosition / containerWidth) * 100;
                mousePercentage = Math.max(0, Math.min(100, mousePercentage));
                const startMinutes = this.getSegmentTimeInMinutes(segment.startTime);
                const endMinutes = this.getSegmentTimeInMinutes(segment.endTime);
                const bufferStart = startMinutes + 5;
                const bufferEnd = endMinutes - 5;
                const formattedStartTime = this.formatTimeFromMinutes(bufferStart);
                const formattedEndTime = this.formatTimeFromMinutes(bufferEnd);
                const bufferStartPercentage = this.calculateTimeValue(formattedStartTime);
                const bufferEndPercentage = this.calculateTimeValue(formattedEndTime);
                if (bufferStartPercentage > mousePercentage || bufferEndPercentage < mousePercentage) {
                    return;
                }
                const segmentRangePercentage = segment.end - segment.start;
                let relativePositionInSegment = ((mousePercentage - segment.start) / segmentRangePercentage) * 100;
                relativePositionInSegment = Math.max(0, Math.min(100, relativePositionInSegment));
                this.splitX = relativePositionInSegment;
                this.hoverX = 100 - relativePositionInSegment;
                if (mousePercentage >= segment.start && mousePercentage <= segment.end) {
                    const totalMinutesFrom6AM = Math.round((mousePercentage / 100) * (18 * 60));
                    this.hoverTime = Math.floor(totalMinutesFrom6AM + 360);
                    this.hoverDisplayTime = this.formatTimeFromMinutes(this.hoverTime);
                }
                else {
                    this.hoverTime = null;
                }
            }
        }
        getSegmentTimeInMinutes(time) {
            time = time.toUpperCase();
            const [timePart, modifier] = time.split(" ");
            let [hours, minutes] = timePart.split(":").map(Number);
            // Convert PM to 24-hour format
            if (modifier === "PM" && hours !== 12) {
                hours += 12;
            }
            // Handle midnight (12:00 AM)
            if (modifier === "AM" && hours === 12) {
                hours = 0;
            }
            // Calculate total minutes
            return hours * 60 + minutes;
        }
        OnSplitHandleStart(event, index) {
            this.dragging = true;
            document.addEventListener("mousemove", this.OnSplitHandleDragging);
            document.addEventListener("mouseup", this.OnSplitDragEnd);
            // Optional: For touch support (if needed)
            document.addEventListener("touchmove", this.OnSplitHandleDragging);
            document.addEventListener("touchend", this.OnSplitDragEnd);
        }
        formatTimeFromMinutes(minutes) {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            const period = hours >= 12 ? "PM" : "AM";
            const formattedHours = hours % 12 || 12; // Convert to 12-hour format
            return `${formattedHours}:${mins.toString().padStart(2, "0")} ${period}`;
        }
        OnSplitDragEnd() {
            this.dragging = false;
            document.removeEventListener("mousemove", this.OnSplitHandleDragging);
            document.removeEventListener("mouseup", this.OnSplitDragEnd);
            // Optional: For touch support (if needed)
            document.addEventListener("touchmove", this.OnSplitHandleDragging);
            document.addEventListener("touchend", this.OnSplitDragEnd);
        }
        splitSegment() {
            this.send({ type: "SPLITING_ENTRY" });
            const splitTimeInMinutes = this.hoverTime;
            const splitTimeFormattedString = this.formatTimeFromMinutes(splitTimeInMinutes);
            const splitTimeTzFormatted = splitTimeFormattedString.toLocaleUpperCase();
            var adjustTime = this.calculateTimeValue(splitTimeTzFormatted);
            if (adjustTime < 0) {
                adjustTime += 100;
            }
            if (adjustTime < 0 || adjustTime > 100) {
                toaster.ShowError("You cannot set the split time beyond the timeline.");
                return;
            }
            const segment = this.segments[this.selectedSegment];
            const startTimeValueAsMinutes = this.getSegmentTimeInMinutes(segment.startTime);
            const endTimeValueAsMinutes = this.getSegmentTimeInMinutes(segment.endTime);
            const splitTimeValueAsMinutes = this.getSegmentTimeInMinutes(splitTimeTzFormatted);
            if (splitTimeValueAsMinutes - startTimeValueAsMinutes < 6) {
                return toaster.ShowError("Split time should be at least 6 minutes from the Start Time.");
            }
            else if (endTimeValueAsMinutes - splitTimeValueAsMinutes < 6) {
                return toaster.ShowError("Split time should be at least 6 minutes before the End Time.");
            }
            var splittedValue = this.calculateTimeValue(splitTimeTzFormatted.toUpperCase());
            var currentSegementEndTime = this.calculateTimeValue(segment.endTime.toUpperCase());
            let entryDate = new Date(segment.entryDate);
            const datePart = entryDate.toISOString().split("T")[0];
            const startTime24Hour = this.parseTimeTo24Hour(segment.startTime);
            const startTimeString = `${datePart}T${startTime24Hour}:00`;
            const startTimeDate = new Date(startTimeString);
            segment.isSplitted = segment.isSplitted;
            segment.endTime = this.formatLabelTime(splittedValue);
            segment.end = splittedValue;
            var newGuid = Guid.create();
            var model = new AdjustEntryModel();
            model.id = newGuid.value;
            model.isRunning = false;
            model.initialStart = splittedValue;
            model.initialEnd = currentSegementEndTime;
            model.start = splittedValue;
            model.end = currentSegementEndTime;
            model.startTime = this.formatLabelTime(splittedValue);
            model.isSplitted = true;
            model.description = segment.description;
            model.taskId = segment.taskId;
            model.endTime = this.formatLabelTime(currentSegementEndTime);
            model.entryAtWork = segment.entryAtWork;
            model.entryDate = segment.entryDate;
            model.orginalStartTime = startTimeDate;
            model.isStopped = false;
            this.segments.splice(this.selectedSegment + 1, 0, model);
            this.selectedSegment = this.selectedSegment + 1;
            const refKey = `entryEndTime-${this.selectedSegment - 1}`;
            const clockPicker = this.$refs[refKey][0];
            if (clockPicker) {
                clockPicker.oldValue = segment.endTime;
            }
            checkGaps(this.segments);
        }
        cancelSplit() {
            this.send({ type: "CANCEL" });
            this.hoverTime = null;
            this.hoverX = 0;
            this.hoverDisplayTime = "";
            this.splitX = 0;
            this.selectedPicker = null;
        }
        updateEntry(index) {
            this.selectedSegment = index;
            this.send({ type: "UPDATE_DESCRIPTION" });
            const inputRef = this.$refs[`description-${this.selectedSegment}`];
            if (inputRef) {
                const isValid = inputRef.value !== "";
                if (isValid) {
                    const segment = this.segments[this.selectedSegment];
                    segment.isDescriptionChanged = true;
                    this.send({ type: "UPDATING_DESCRIPTION" });
                }
            }
        }
        endSegment() {
            const runningSegment = this.segments.find((seg) => seg.isRunning);
            var index = this.segments.indexOf(runningSegment);
            if (index != -1) {
                this.selectedSegment = index;
            }
            if (runningSegment) {
                runningSegment.isRunning = false;
                runningSegment.isStopped = true;
            }
            this.send({ type: "STOP_ENTRY" });
        }
        deleteSegment(index) {
            this.send({ type: "DELETE_ENTRY" });
            if (index != -1) {
                this.selectedSegment = index;
            }
            this.segmentId = this.segments[this.selectedSegment].id;
        }
        deletingEntry() {
            var exitingEntry = this.entries.find((f) => f.id == this.segmentId);
            if (exitingEntry) {
                this.state.context.deletedEntries.push(exitingEntry.id);
            }
            this.segments = this.segments.filter((segment) => segment.id !== this.segmentId);
            this.send({ type: "DELETING_ENTRY" });
            checkGaps(this.segments);
        }
        cancel() {
            this.segmentId = null;
            this.send({ type: "CANCEL" });
        }
        getEndingTitleMessage(index) {
            const entry = this.segments[index];
            if (entry.upFillApplicable) {
                return this.gapFillMsg + entry.upFillHover + this.gapFillMsgUp;
            }
            return "";
        }
        getStartingTitleMessage(index) {
            const entry = this.segments[index];
            if (entry.downFillApplicable) {
                return this.gapFillMsg + entry.downFillHover + this.gapFillMsgDown;
            }
            return "";
        }
        onBlur() {
            this.send({ type: "ADJUST_ENTRIES" });
        }
        downFill(index) {
            if (index <= 0)
                return;
            const currentSegment = this.segments[index];
            const previousSegment = this.segments[index - 1];
            // Sync start time with previous segment's end
            currentSegment.startTime = previousSegment.endTime;
            currentSegment.start = previousSegment.end;
            const refKey = `entryStartTime-${index}`;
            const clockPicker = this.$refs[refKey][0];
            if (clockPicker) {
                clockPicker.oldValue = previousSegment.endTime;
            }
            checkGaps(this.segments);
        }
        upFill(index) {
            if (index >= this.segments.length - 1)
                return;
            const currentSegment = this.segments[index];
            const nextSegment = this.segments[index + 1];
            // Sync start time with previous segment's end
            currentSegment.endTime = nextSegment.startTime;
            currentSegment.end = nextSegment.start;
            const refKey = `entryEndTime-${index}`;
            const clockPicker = this.$refs[refKey][0];
            if (clockPicker) {
                clockPicker.oldValue = nextSegment.startTime;
            }
            checkGaps(this.segments);
        }
        getRecentEntries() {
            this.send({ type: "GET_ENTRIES" });
            this.selectedSegment = 0;
            var mappedSegments = this.mappedSegments();
            this.segments = _.orderBy(mappedSegments, ["orginalStartTime"], ["asc"]);
            this.$nextTick(() => {
                this.focusDescriptionInput(this.selectedSegment);
                checkGaps(this.segments);
            });
        }
        mappedSegments() {
            return this.entries.map((entry) => {
                var isRunning = entry.endTimeTzFormatted == "now";
                var startValue = this.calculateTimeValue(entry.startTimeTzFormatted.toUpperCase());
                var endValue = !isRunning ? this.calculateTimeValue(entry.endTimeTzFormatted.toUpperCase()) : this.currentTimeInPercentage;
                var model = new AdjustEntryModel();
                model.id = entry.id;
                model.isRunning = isRunning;
                model.initialStart = startValue;
                model.initialEnd = endValue;
                model.start = startValue;
                model.end = endValue;
                model.startTime = this.formatLabelTime(startValue);
                model.isSplitted = false;
                model.taskId = entry.taskId;
                model.description = entry.description?.trim() === "" ? "Untitled Entry" : entry.description;
                //model.endTime = !isRunning ? this.formatLabelTime(endValue) : "now";
                model.endTime = this.formatLabelTime(endValue);
                model.entryAtWork = entry.entryAtWork;
                model.entryDate = entry.startTime;
                model.orginalStartTime = entry.startTime;
                model.isStopped = false;
                model.downFillApplicable = false;
                model.upFillApplicable = false;
                model.upFillHover = "";
                model.downFillHover = "";
                return model;
            });
        }
        close() {
            this.$emit("close");
        }
        handleKeydown(event) {
            if (event.altKey && event.key === "s") {
                event.preventDefault();
                this.handleSplitEntry(this.selectedSegment);
            }
        }
        onSegmentsChange() {
            const entriesToUpdate = this.segments.filter((segment) => {
                return segment.start !== segment.initialStart || segment.end !== segment.initialEnd || segment.isSplitted || segment.isDescriptionChanged || segment.isStopped;
            });
            const value = entriesToUpdate.length > 0 || this.state.context.deletedEntries.length > 0;
            this.$emit("dragging-updated", value);
        }
        onSelectedSegmentChange(newIndex) {
            if (newIndex !== null) {
                this.focusDescriptionInput(newIndex);
            }
        }
        focusDescriptionInput(index) {
            this.$nextTick(() => {
                const inputRef = this.$refs[`description-${index}`];
                if (inputRef[0]) {
                    inputRef[0].focus();
                    inputRef[0].select();
                }
            });
        }
        created() {
            this.getRecentEntries();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                if (this.state.matches("idle") && this.previousState.matches("entriesLoaded.savingEntries")) {
                    this.close();
                }
            });
        }
        mounted() {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    this.focusDescriptionInput(this.selectedSegment);
                });
            });
            if (this.isToday && this.segments.some((x) => x.isRunning)) {
                this.interval = setInterval(() => {
                    if (new Date().getSeconds() === 0) {
                        this.updateTime();
                        var runningEntry = this.segments.find((x) => x.isRunning);
                        runningEntry.end = this.currentTimeInPercentage;
                        runningEntry.endTime = this.formatLabelTime(runningEntry.end);
                        this.refreshClockPickerKey = !this.refreshClockPickerKey;
                    }
                }, 1000);
            }
            window.addEventListener("keydown", this.handleKeydown);
        }
        beforeDestroy() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        }
        beforeUnmount() {
            window.removeEventListener("keydown", this.handleKeydown);
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], AdjustEntrySlider.prototype, "entries", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], AdjustEntrySlider.prototype, "isToday", void 0);
    __decorate([
        Watch("segments", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AdjustEntrySlider.prototype, "onSegmentsChange", null);
    __decorate([
        Watch("selectedSegment", { deep: true, immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AdjustEntrySlider.prototype, "onSelectedSegmentChange", null);
    AdjustEntrySlider = __decorate([
        Component({
            name: "AdjustEntrySlider",
            components: {
                clockPicker,
                simplebar,
                DeleteComponent,
            },
        })
    ], AdjustEntrySlider);
    return AdjustEntrySlider;
})();
export default AdjustEntrySlider;
